import { render, staticRenderFns } from "./tagbox-filter.vue?vue&type=template&id=dc2bc686&"
import script from "./tagbox-filter.vue?vue&type=script&lang=ts&"
export * from "./tagbox-filter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc2bc686')) {
      api.createRecord('dc2bc686', component.options)
    } else {
      api.reload('dc2bc686', component.options)
    }
    module.hot.accept("./tagbox-filter.vue?vue&type=template&id=dc2bc686&", function () {
      api.rerender('dc2bc686', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/tagbox/tagbox-filter.vue"
export default component.exports